export default {
  getTiposCertificado(state) {
    return state.tiposCertificado;
  },
  getTotalItems(state) {
    return state.tiposCertificado.totalItems;
  },
  getItensCertificado(state) {
    return state.tiposCertificado.items;
  },
  getItemById: (state) => (id) => {
    return state.tiposCertificado.items.find((item) => {
      return item.id == id
    });
  }
}